/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../api/index';
import * as core from '../../../../core';
import * as serializers from '../../../index';

export const PresentationIssueRequestCompositionType: core.serialization.Schema<
    serializers.PresentationIssueRequestCompositionType.Raw,
    Truvity.PresentationIssueRequestCompositionType
> = core.serialization.enum_(['EMBED']);

export declare namespace PresentationIssueRequestCompositionType {
    export type Raw = 'EMBED';
}
